import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';
import { GroupListRequest, GroupList } from '../interfaces/group.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  public eventSearch = new EventEmitter<string>();
  private urlProd: string = environment.apiRoot;

  public nameCompany = new BehaviorSubject<string>('');
  public shareName = this.nameCompany.asObservable();

  constructor(private http: HttpClient) {}

  private _refresrequired = new Subject<void>();

  public refreshGroupTable$ = new EventEmitter<boolean>();
  public filterByStatusCompany$ = new EventEmitter<string>();

  get Refreshrequired() {
    return this._refresrequired;
  }

  emitSearchCompany(search: string): any {
    return this.eventSearch.emit(search);
  }

  sharenameCompany(name: string): any {
    this.nameCompany.next(name);
  }

  //groups
  madeGtoup(id_facilitator: string, id_allied: string, body: any) {
    return this.http
      .post(
        `${this.urlProd}groups-companies/add-group?id_facilitator=${id_facilitator}&id_allied=${id_allied}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap((value) => {
          this.Refreshrequired.next();
        })
      );
  }

  public zohoLogs(page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name") {
    let baseUrl = new URL(`${this.urlProd}groups-companies/zoho-logs?page=${page}&limit=${limit}`);

    let searchParams = baseUrl.searchParams;
    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }



  public groupList(alliedId: string, page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name", facilitatorId?: string) {
    let baseUrl = new URL(`${this.urlProd}groups-companies/paged-list-group?id_allied=${alliedId}&page=${page}&limit=${limit}`);

    let searchParams = baseUrl.searchParams;

    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    if (facilitatorId) {
      searchParams.set('id_facilitator', facilitatorId);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }

  public getGroupList(request: GroupListRequest): Observable<GroupList> {
    const params = new HttpParams()
      .set('page', request.page ? request.page.toString() : '0')
      .set('limit', request.limit ? request.limit.toString() : '0')
      .set('id_allied', request.id_allied ? request.id_allied : '');

    if (request.search) {
      params.append('search', request.search);
    }

    return this.http.get<GroupList>(
      `${this.urlProd}groups-companies/list-group`,
      {
        params,
        context: checkToken(),
      }
    );
  }

  getGroupListByAllied(
    search: any,
    page: number,
    limit: number,
    id_allied: string
  ) {
    return this.http.get(`${this.urlProd}groups-companies/list-group`, {
      params: {
        search,
        page,
        limit,
        id_allied,
      },
      context: checkToken(),
    });
  }

  getGroupDetail(id_group: string) {
    return this.http.get(`${this.urlProd}groups-companies/detail-group?$`, {
      params: { id_group },
      context: checkToken(),
    });
  }

  getBussinesList(search: any, page: number, limit: number) {
    return this.http.get(`${this.urlProd}groups-companies/list-company`, {
      params: {
        search,
        page,
        limit,
      },
      context: checkToken(),
    });
  }

  update(id_group: string, body: any, id_facilitator?: string) {
    return this.http
      .put(
        `${this.urlProd}groups-companies/update-group?id_group=${id_group}&id_facilitator=${id_facilitator}`,
        body,
        { context: checkToken() }
      );
  }

  deleteGroup(id: string) {
    return this.http
      .delete(
        `${this.urlProd}groups-companies/delete-group?id_group=${id}`,
        { context: checkToken() }
      );
  }

  updateGroup(id_group: string, body: any, id_facilitator?: string) {
    return this.http
      .put(
        `${this.urlProd}groups-companies/update-group?id_group=${id_group}&id_facilitator=${id_facilitator}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  //companies
  madeCompany(id: string, body: any) {
    return this.http
      .post(
        `${this.urlProd}groups-companies/add-company?id_group=${id}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  getListCompany(search: any, page: number, limit: number) {
    return this.http.get(`${this.urlProd}groups-companies/list-company`, {
      params: { search, page, limit },
      context: checkToken(),
    });
  }

  getListCompanyByGroup(
    search: any,
    page: number,
    limit: number,
    id_group: string
  ) {
    return this.http.get(`${this.urlProd}groups-companies/list-company`, {
      params: { search, page, limit, id_group },
      context: checkToken(),
    });
  }

  getCompany(id: string) {
    return this.http.get(
      `${this.urlProd}groups-companies/detail-company?id_company=${id}`,
      { context: checkToken() }
    );
  }

  editCompany(id: string, body: any) {
    return this.http
      .put(
        `${this.urlProd}groups-companies/update-company?id_company=${id}`,
        body,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  deleteCompany(id_company: string) {
    return this.http
      .delete(
        `${this.urlProd}groups-companies/delete-company?id_company=${id_company}`,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  //refreshing

  public refreshGroupList(isRefresh: boolean) {
    this.refreshGroupTable$.emit(isRefresh);
  }

  public filterStatus(status: string) {
    this.filterByStatusCompany$.emit(status);
  }

  //downloadCVS file
  getLayOutCompanies() {
    return this.http.get(
      `${this.urlProd}groups-companies/download-layout-company`,
      { responseType: 'blob', context: checkToken() }
    );
  }

  //saveFiles
  uploadCsvFile(idGroup: any, file: any, query?: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    if (query) {
      return this.http
        .post(
          `${this.urlProd}groups-companies/upload-company?id_group=${idGroup}&continue=${query}`,
          formData,
          { context: checkToken() }
        )
        .pipe(
          tap(() => {
            this.Refreshrequired.next();
          })
        );
    } else {
      return this.http
        .post(
          `${this.urlProd}groups-companies/upload-company?id_group=${idGroup}`,
          formData,
          { context: checkToken() }
        )
        .pipe(
          tap(() => {
            this.Refreshrequired.next();
          })
        );
    }
  }

  //dashboardData

  getDataComplete(id_allied: string) {
    return this.http.get(
      `${this.urlProd}groups-companies/companies-dashboard?id_allied=${id_allied}`,
      { context: checkToken() }
    );
  }

  getDataGroupByYear(id_allied: string, year: string) {
    return this.http.get(
      `${this.urlProd}groups-companies/companies-dashboard?id_allied=${id_allied}&year=${year}`,
      { context: checkToken() }
    );
  }

  getDataDetailGroup(id: string) {
    return this.http.get(
      `${this.urlProd}groups-companies/groups-dashboard?id_group=${id}`,
      { context: checkToken() }
    );
  }
}
